export default __webpack_public_path__ + "static/media/mastercard-logo.3074f666.png";